








import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class RenderData extends Vue {
  @Prop({type: [String, Number], default: null}) value!: string | number | null
  @Prop({type: String}) renderClass?: string
  @Prop({type: String}) innerClass?: string
}
